import React, { useState, useEffect } from 'react';
import './UserDashboard.css';
import ManagementCard from '../../components/ManagementCard/ManagementCard';
import Loading from '../../components/Loading/Loading';
import Modal from '../../components/Modal/Modal';

const UserDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    useEffect(() => {
            const handleBeforeUnload = (event) => {
                if (loading) {
                    event.preventDefault();
                    event.returnValue = '';
                }
            };
    
            window.addEventListener('beforeunload', handleBeforeUnload);
            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }, [loading]);
    
        useEffect(() => {
            const handleKeyDown = (event) => {
                if (loading && (event.key === 'F5' || (event.ctrlKey && event.key === 'r'))) {
                    event.preventDefault();
                }
            };
    
            window.addEventListener('keydown', handleKeyDown);
            return () => {
                window.removeEventListener('keydown', handleKeyDown);
            };
        }, [loading]);

    useEffect(() => {
        localStorage.removeItem('r-type');
        localStorage.removeItem('r-title');
        localStorage.removeItem('r-language');

        const showModal = localStorage.getItem('show_modal');
        if (showModal === 'true') {
            setModalData({
                isVisible: true,
                message: 'کاربر عزیز شما با موقیت وارد شدید',
                type: 'success',
            });
        }
    }, []);

    return (
        <>
            {loading && (
                <Loading />
            )}
            <div className="dashboard-container container">
                <ManagementCard setIsLoading={setLoading} setModal={setModalData} title={'پروفایل'} methods={['مشاهده پروفایل', 'بروزرسانی پروفایل']} href_list={['/user/profile', '']} name_list={['', 'update-profile']} />
                <ManagementCard setIsLoading={setLoading} setModal={setModalData} title={'مدیریت رزومه'} methods={['لیست فعالیت ها', 'بروزرسانی رزومه']} href_list={['/user/activities', '']} name_list={['', 'update-activities']} />
            </div>
            <Modal
                message={modalData.message}
                type={modalData.type}
                isVisible={modalData.isVisible}
                onClose={() => setModalData({ ...modalData, isVisible: false })}
            />
        </>
    );
};

export default UserDashboard;
